import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Mountain } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const NAV = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/premium", label: "Premium" },
  { to: "/contact", label: "İletişim" },
];

export function Header() {
  const { settings } = useSite();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-md bg-[#0A1A10]/90 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[70px] flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 text-white">
          <span className="grid place-items-center h-9 w-9 rounded-full bg-[#1B4D2E] border border-[#D4AF37]/40">
            <Mountain className="h-5 w-5 text-[#D4AF37]" />
          </span>
          <span className="font-serif-display text-xl font-bold tracking-tight">
            {settings.site_title || "Saklı Rota"}
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace(/\//g, "") || "home"}`}
              className={`text-sm font-medium transition-colors ${
                pathname === n.to ? "text-[#D4AF37]" : "text-white/80 hover:text-white"
              }`}
            >
              {n.label}
            </Link>
          ))}
          <a
            href={settings.google_play_url || "#"}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-download-btn"
            className="text-sm font-semibold px-5 py-2.5 rounded-full bg-[#D4AF37] text-[#0F2F1D] hover:bg-[#C59B27] transition-colors"
          >
            İndir
          </a>
        </nav>

        <button
          data-testid="mobile-menu-btn"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menü"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden backdrop-blur-md bg-[#0A1A10]/95 border-t border-white/10 px-5 py-6 space-y-1">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`mobile-nav-${n.to.replace(/\//g, "") || "home"}`}
              className="block py-3 text-white/90 text-lg font-medium border-b border-white/5"
            >
              {n.label}
            </Link>
          ))}
          <a
            href={settings.google_play_url || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 block text-center font-semibold px-5 py-3 rounded-full bg-[#D4AF37] text-[#0F2F1D]"
          >
            Google Play'den İndir
          </a>
        </div>
      )}
    </header>
  );
}
